import { NgModule } from '@angular/core';

import { LogService } from './logger.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [LogService],
  exports: [],
})
export class LogModule {}
